// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.zgK559pLAgsVvDEL {
  position: relative;
  padding: 12px;
}
.zgK559pLAgsVvDEL .mkVHnegEEuMa6Vtp {
  position: absolute;
  display: flex;
  align-items: center;
  justify-content: center;
  top: -39px;
  left: 7px;
  width: 30px;
  height: 30px;
  color: #333;
  z-index: 100;
}
.zgK559pLAgsVvDEL .jEkdY0g8jsgmbU2g {
  margin-bottom: 16px;
}
.zgK559pLAgsVvDEL .cPNEUGqifBIZkwf_ {
  padding: 12px 16px;
  margin-bottom: 12px;
  background: #fff;
  border-radius: 8px;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);
}
.zgK559pLAgsVvDEL .cPNEUGqifBIZkwf_ .mG3mCho4GMJEMIv2 {
  display: flex;
  flex-direction: column;
  width: 100%;
}
.zgK559pLAgsVvDEL .cPNEUGqifBIZkwf_ .CJGDfDsssaLka6nD {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 8px;
}
.zgK559pLAgsVvDEL .cPNEUGqifBIZkwf_ .xeAhyBaprgLtRxwM {
  font-weight: 500;
  color: #333;
  font-size: 14px;
}
.zgK559pLAgsVvDEL .cPNEUGqifBIZkwf_ .ISMjmt24RHx4ok2R {
  color: #999;
  font-size: 12px;
}
.zgK559pLAgsVvDEL .cPNEUGqifBIZkwf_ .c1z6J2bnnVUxGt5d {
  margin-bottom: 12px;
  color: #333;
  font-size: 14px;
  line-height: 1.5;
  word-break: break-word;
  white-space: pre-line;
}
.zgK559pLAgsVvDEL .cPNEUGqifBIZkwf_ .p4q2HIZzwMsapSRa {
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
  margin-top: 8px;
}
.zgK559pLAgsVvDEL .cPNEUGqifBIZkwf_ .b5UzcxyLuE4SK8HH {
  border-radius: 4px;
  object-fit: cover;
}
.zgK559pLAgsVvDEL .b5UzcxyLuE4SK8HH {
  border-radius: 4px;
}
@media (max-width: 768px) {
  .zgK559pLAgsVvDEL .WwKbjmBEO1cNxuxk {
    padding: 0;
    margin-top: 12px;
  }
  .zgK559pLAgsVvDEL .qoZqZI9UgroWNoiH {
    flex-direction: column;
    height: auto;
  }
  .zgK559pLAgsVvDEL .qoZqZI9UgroWNoiH .PDKtql0d7B0rgG3t {
    margin-bottom: 8px;
  }
}
`, "",{"version":3,"sources":["webpack://./app/assets/pages/complaint _detail/index.modules.less"],"names":[],"mappings":"AAcA;EACE,kBAAA;EACA,aAAA;AAbF;AAWA;EAKI,kBAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,UAAA;EACA,SAAA;EACA,WAAA;EACA,YAAA;EACA,WAAA;EACA,YAAA;AAbJ;AADA;EAkBI,mBAAA;AAdJ;AAJA;EAuBI,kBAAA;EACA,mBAAA;EACA,gBAAA;EACA,kBAAA;EACA,wCAAA;AAhBJ;AAXA;EA8BM,aAAA;EACA,sBAAA;EACA,WAAA;AAhBN;AAhBA;EAoCM,aAAA;EACA,8BAAA;EACA,mBAAA;EACA,kBAAA;AAjBN;AAtBA;EA2CM,gBAAA;EACA,WAAA;EACA,eAAA;AAlBN;AA3BA;EAiDM,WAAA;EACA,eAAA;AAnBN;AA/BA;EAsDM,mBAAA;EACA,WAAA;EACA,eAAA;EACA,gBAAA;EACA,sBAAA;EACA,qBAAA;AApBN;AAvCA;EA+DM,aAAA;EACA,eAAA;EACA,QAAA;EACA,eAAA;AArBN;AA7CA;EAsEM,kBAAA;EACA,iBAAA;AAtBN;AAjDA;EA4EI,kBAAA;AAxBJ;AA4BE;EAAA;IAEI,UAAA;IACA,gBAAA;EA1BJ;EAuBA;IAOI,sBAAA;IACA,YAAA;EA3BJ;EAmBA;IAWM,kBAAA;EA3BN;AACF","sourcesContent":["// .complaintWrapper {\n//   margin: 20px auto;\n//   width: 1200px;\n// }\n// .bodyCard {\n//     margin: 20px 0;\n// }\n\n// .Image {\n//   object-fit: cover;\n//   margin: 0 2px 2px 0;\n// }\n// index.modules.less\n\n.complaintWrapper {\n  position: relative;\n  padding: 12px;\n\n  .back {\n    position: absolute;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    top: -39px;\n    left: 7px;\n    width: 30px;\n    height: 30px;\n    color: #333;\n    z-index: 100;\n  }\n\n  .bodyCard {\n    margin-bottom: 16px;\n  }\n  \n  // 移动端卡片样式\n  .mobileCard {\n    padding: 12px 16px;\n    margin-bottom: 12px;\n    background: #fff;\n    border-radius: 8px;\n    box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);\n    \n    .cardContentWrapper {\n      display: flex;\n      flex-direction: column;\n      width: 100%;\n    }\n    \n    .cardMeta {\n      display: flex;\n      justify-content: space-between;\n      align-items: center;\n      margin-bottom: 8px;\n    }\n    \n    .cardRole {\n      font-weight: 500;\n      color: #333;\n      font-size: 14px;\n    }\n    \n    .cardTime {\n      color: #999;\n      font-size: 12px;\n    }\n    \n    .cardContent {\n      margin-bottom: 12px;\n      color: #333;\n      font-size: 14px;\n      line-height: 1.5;\n      word-break: break-word;\n      white-space: pre-line;\n    }\n    \n    .cardImages {\n      display: flex;\n      flex-wrap: wrap;\n      gap: 8px;\n      margin-top: 8px;\n    }\n    \n    .mobileImage {\n      border-radius: 4px;\n      object-fit: cover;\n    }\n  }\n  \n  .mobileImage {\n    border-radius: 4px;\n  }\n  \n  // 移动端按钮组调整\n  @media (max-width: 768px) {\n    .ant-card-extra {\n      padding: 0;\n      margin-top: 12px;\n    }\n    \n    .ant-steps {\n      flex-direction: column;\n      height: auto;\n      \n      .ant-steps-item {\n        margin-bottom: 8px;\n      }\n    }\n  }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"complaintWrapper": `zgK559pLAgsVvDEL`,
	"back": `mkVHnegEEuMa6Vtp`,
	"bodyCard": `jEkdY0g8jsgmbU2g`,
	"mobileCard": `cPNEUGqifBIZkwf_`,
	"cardContentWrapper": `mG3mCho4GMJEMIv2`,
	"cardMeta": `CJGDfDsssaLka6nD`,
	"cardRole": `xeAhyBaprgLtRxwM`,
	"cardTime": `ISMjmt24RHx4ok2R`,
	"cardContent": `c1z6J2bnnVUxGt5d`,
	"cardImages": `p4q2HIZzwMsapSRa`,
	"mobileImage": `b5UzcxyLuE4SK8HH`,
	"ant-card-extra": `WwKbjmBEO1cNxuxk`,
	"ant-steps": `qoZqZI9UgroWNoiH`,
	"ant-steps-item": `PDKtql0d7B0rgG3t`
};
export default ___CSS_LOADER_EXPORT___;
